import React from 'react'
import { Box, Typography } from '@mui/material'
import CustomTooltip from '../../../components/CustomTooltip'
import { grey } from '../../../colors'
import { formatQuestionSampleStat, formatSampleCount, type QuestionSampleStats } from './questionSampleSize'
import ReportsChip from './ReportsChip'

interface QuestionSampleSizeRowProps {
  stats: QuestionSampleStats[] | null
}

const QuestionSampleSizeRow: React.FC<QuestionSampleSizeRowProps> = ({ stats }) => {
  if (!stats?.length) {
    return null
  }

  if (stats.length === 1) {
    return (
      <Typography variant="body2" color={grey[500]}>
        {formatQuestionSampleStat(stats[0])}
      </Typography>
    )
  }

  return (
    <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
      <Typography variant="body2" color={grey[500]}>
        N:
      </Typography>
      {stats.map((stat, index) => (
        <CustomTooltip key={stat.label} title={formatQuestionSampleStat(stat)}>
          <span>
            <ReportsChip
              index={index}
              label={formatSampleCount(stat.n)}
            />
          </span>
        </CustomTooltip>
      ))}
    </Box>
  )
}

export default QuestionSampleSizeRow
